import axios from "axios";

// La app siempre sirve frontend y backend en el MISMO dominio (preview, producción
// y dominio personalizado). Usamos el origen actual para que el login funcione sin
// importar desde qué dominio se acceda (recetrans.com o *.emergent.host).
const BACKEND_URL =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !original.url.includes("/auth/")
    ) {
      original._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch (refreshError) {
        console.warn("No se pudo refrescar la sesión:", refreshError?.response?.status || refreshError.message);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(error) {
  return formatApiErrorDetail(error?.response?.data?.detail) || error.message;
}
